<template>
  <div class="good-info-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="base-info group">
          <div class="basic">
            <!-- <span>*</span> -->
            创建文章
          </div>
          <el-form
            ref="form"
            :rules="rules"
            :model="form"
            class="good-form base-info-form"
            label-width="auto"
          >
            <el-form-item label="文章标题" prop="name" class="form-item">
              <el-input
                placeholder="请输入文章名称"
                v-model="form.title"
                class="good-input"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="关联分类"
              prop="secondSortId"
              class="form-item"
            >
              <el-select
                v-model.number="form.sortId"
                placeholder="全部"
                class="input"
              >
                <el-option
                  v-for="item in categoryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品图片" class="form-item" prop="masterPic">
              <p class="tips" style="margin-bottom: 8px">
                建议尺寸：720*400，图片类型jpg、png
              </p>
              <div class="img-box">
                <imgUpLoader
                  :max-pic-num="1"
                  @getPics="getMasterImgList"
                  :index="0"
                  text="封面"
                  :imgUrl="form.pic"
                />
              </div>
            </el-form-item>
            <!-- <el-form-item label="宣传语" prop="tagline" class="form-item">
              <el-input
                placeholder="商品备注/副标题"
                v-model="form.tagline"
                class="good-input"
              ></el-input>
              <span class="tip">商品描述不要超过四十个字</span>
            </el-form-item> -->
            <el-form-item label="排序" prop="orderBy" class="form-item">
              <el-input
                placeholder="请输入"
                v-model.number="form.orderBy"
                class="good-input"
                style="width: 185px"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="文章内容" prop="content" class="form-item">
              <WangEditor
                :text="form.content"
                class="text"
                @change="changeText"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="btn-box">
          <button class="cancel-btn" @click="handleCancel">取消</button>
          <button class="confirm-btn" @click="handleConfirm">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import imgUpLoader from '../../components/goods/imgUpLoader';
import WangEditor from '../../components/common/wang-edit';
export default {
  components: { Header, imgUpLoader, WangEditor },
  name: 'goods-lock',
  data() {
    return {
      loading: 0,
      title: {
        // 页面标题
        firstTitile: '商品管理',
        secondTitle: '云课堂文章管理'
      },
      rules: {},
      id: null,
      form: {
        title: '',
        tagline: '',
        pic: '',
        orderBy: null,
        sortId: null,
        content: ''
      },
      categoryList: []
    };
  },
  computed: {},
  async mounted() {
    // this.getBusinessList();
    await this.getCategoryList();
    // this.getFreightList();
    let query = this.$route.query;
    if (query && query.id) {
      this.id = +query.id;
      this.getDetail();
    }
  },
  methods: {
    // 获取商品信息
    getDetail() {
      this.loading++;
      this.httpGet(this.$root.getArticleInfo, { id: this.id }).then(
        (res) => {
          this.loading--;
          let form = {};
          for(let key in this.form){
            form[key] = res[key];
          };
          this.form = form;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 获取分类列表
    getCategoryList() {
      this.loading++;
      this.httpGet(this.$root.getArticleCategoryList, {}).then(
        (res) => {
          this.loading--;
          this.categoryList = res;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    changeText(val) {
        // 文本更改
        this.form.content = val;
    },
    getMasterImgList(index, val) {
      if (val === '') {
        // slideshow.splice(index, 1);
        this.form.pic = '';
      } else {
        this.form.pic = val;
      }
      this.$refs.form.clearValidate(['masterPic']);
    },
    handleCancel(){

    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.addGood();
        } else {
          this.$message({
            message: '请填写文章信息',
            type: 'warning'
          });
        }
      });
    },
    // 添加商品
    addGood() {
      // 请求数据
      let inputData = {
        ...this.form
      };
      // inputData.spu.freight = 1;
      // 是否为编辑商品
      let method = 'httpPost';
      if (this.id) {
        method = 'httpPut';
        inputData.id = this.id;
      }
      this.loading++;
      this[method](
        this.id ? this.$root.updateArticle : this.$root.addArticle, // 添加商品 or 创建商品
        inputData
      ).then(
        (res) => {
          this.$message({
            message: this.gid ? '文章修改成功' : '文章创建成功',
            type: 'success'
          });
          this.loading--;
          this.$router.push({
            name: 'article'
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.good-info-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      // background: white;
      box-sizing: border-box;
      // padding: 24px 20px;
      border-radius: 2px;

      .group {
        background: white;
        padding: 10px 0;
        margin-bottom: 10px;
        .basic {
          height: 48px;
          line-height: 48px;
          font-size: 20px;
          text-indent: 20px;
          // margin-top: 20px;
          color: gray3;
          flex-x(flex-start);

          span {
            // color: red;
            color: gray6;
            margin-right: 3px;
          }
        }
      }

      .base-info {
        // margin-bottom: 10px;
        background: white;

        .good-form {
          padding: 20px 0 30px;

          .img-box {
            flex-x(flex-start);
          }
        }

        .base-info-form {
          margin-left: 90px;
        }

        .good-input {
          width: 620px;
        }

        .tip {
          font-size: 14px;
          color: gray6;
          margin-left: 16px;
        }

        .red {
          color: red;
        }

        .option-box {
          background: #F7F8FA;
          padding: 0 24px;
          border-radius: 2px;
          border: 1px solid #E8E8E8;
          // height: 32px;
          overflow: hidden;

          .option-item {
            flex-x(flex-start);
            height: 40px;

            &.option-head {
              height: 32px;
            }

            input {
              height: 32px;
              background: #fff;
              border: 1px solid #E8E8E8;
              box-sizing: border-box;
            }

            .cell1 {
              width: 330px;

              input {
                width: 310px;
                padding: 0 10px;
                box-sizing: border-box;
              }
            }

            .cell2 {
              input {
                width: 500px;
                padding: 0 10px;
                box-sizing: border-box;
              }
            }
          }

          .option-btn {
            width: 94px;
            height: 32px;
            border: 1px solid #E8E8E8;
            box-sizing: border-box;
            background: #fff;
            flex-x(center);
            font-size: 14px;
            border-radius: 2px;
            cursor: pointer;
            margin-top: 12px;
            margin-bottom: 16px;
          }
        }

        .row{
          flex-x(flex-start);
          .item{
            height: 66px;
            flex-x(flex-start);
            .label{
              width: 200px;
              margin-right: 36px;
              text-align: right;
            }
          }
        }
      }

      .good-detail {
        padding-bottom: 50px;
      }
    }
  }

  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    height: 100px !important;
    flex-shrink: 0;
    // padding-bottom: 48px;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }
}
</style>
